import React, { Component } from 'react'
import INITIAL_DATA from '../../../initial-data.json'

const IMAGE_WIDTH = 1000
const IMAGE_HEIGHT = 657

export default function withInitial(WrappedComponent) {
    return class extends Component {
        constructor(props) {
            super(props)
            this.state = {
                mounted: false,
            }
            this._box = null
            this._request = null

            let initialData = JSON.parse(window.localStorage.getItem('rooms'))
            if (!initialData) {
                initialData = INITIAL_DATA
                window.localStorage.setItem(
                    'rooms',
                    JSON.stringify(INITIAL_DATA)
                )
            }

            this._initialData = initialData.rooms.filter(
                (d) => d.id == props.match.params.id
            )[0]
        }

        resizeWindow = () => {
            if (!this._request) {
                this._request = requestAnimationFrame(this.resizePaper)
            }
        }

        resizePaper = () => {
            this.forceUpdate()
            this._request = null
        }

        componentDidMount() {
            this.setState({ mounted: true })
            window.addEventListener('resize', this.resizeWindow)
        }

        componentWillUnmount() {
            if (this._request) {
                cancelAnimationFrame(this._request)
                this._request = null
            }
            window.removeEventListener('resize', this.resizeWindow)
        }

        render() {
            const { imageSize, mounted } = this.state
            const box = this._box && this._box.getBoundingClientRect()
            const initialLocalStorage = window.localStorage.getItem('data')

            return (
                <WrappedComponent
                    {...this.props}
                    initialData={
                        initialLocalStorage != null
                            ? JSON.parse(initialLocalStorage)
                            : this._initialData
                    }
                    imageWidth={IMAGE_WIDTH}
                    imageHeight={IMAGE_HEIGHT}
                    imageSize={imageSize}
                    width={1000}
                    height={window.innerHeight}
                />
            )
        }
    }
}
